import React from "react";
import { ConvertDate } from "../../Function";
import { Calendar } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
const Calender = ({ form, setForm, nested = false, keyData, label }) => {
  return (
    <div>
      <label>{label}</label>
      <Calendar
        onChange={data => {
          if (nested) {
            setForm({
              ...form,
              [nested]: {
                ...form[nested],
                [keyData]: ConvertDate(
                  `${data.year}/${data.month.number}/${data.day}`
                ),
              },
            });
          } else {
            setForm({
              ...form,
              [keyData]: ConvertDate(
                `${data.year}/${data.month.number}/${data.day}`
              ),
            });
          }
        }}
        calendar={persian}
        // multiple={true}
        locale={persian_fa}
      />
    </div>
  );
};

export default Calender;
